export const load = (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 20.6665L5.66669 12.3332L8.00002 9.9165L12.3334 14.2498V0.666504H15.6667V14.2498L20 9.9165L22.3334 12.3332L14 20.6665ZM4.00002 27.3332C3.08335 27.3332 2.29863 27.0068 1.64585 26.354C0.993076 25.7012 0.666687 24.9165 0.666687 23.9998V18.9998H4.00002V23.9998H24V18.9998H27.3334V23.9998C27.3334 24.9165 27.007 25.7012 26.3542 26.354C25.7014 27.0068 24.9167 27.3332 24 27.3332H4.00002Z" fill="url(#paint0_linear_59_2965)"/>
    <defs>
    <linearGradient id="paint0_linear_59_2965" x1="21.8788" y1="4.6665" x2="8.48994" y2="31.2704" gradientUnits="userSpaceOnUse">
    <stop stop-color="#1D2A32"/>
    <stop offset="1" stop-color="#2A3E3D"/>
    </linearGradient>
    </defs>
  </svg>
)
